import { Delete, Get, getAPIUrl, Post } from "../../../services/apiMethod";

export const SubscriptionEndpoint = {
  getSubscriptionData: `/admin/get-subscription`,
  deleteSubscriptionData: `/admin/delete-subscription`,
  getExportData: `/admin/get-subscription-excel`,
};
export const getSubscriptionData = (param = "") => {
  const url = getAPIUrl(SubscriptionEndpoint.getSubscriptionData, param);
  return Get(url);
};
export const getExportData = (param = "") => {
  const url = getAPIUrl(SubscriptionEndpoint.getExportData, param);
  return Get(url);
};
export const deleteSubscriptionData = (data, param = "") => {
  const url = getAPIUrl(SubscriptionEndpoint.deleteSubscriptionData, param);
  return Post(url, data, true);
};
